import { render, staticRenderFns } from "./DeviceTable.vue?vue&type=template&id=39626420&scoped=true"
import script from "./DeviceTable.vue?vue&type=script&lang=js"
export * from "./DeviceTable.vue?vue&type=script&lang=js"
import style0 from "./DeviceTable.vue?vue&type=style&index=0&id=39626420&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39626420",
  null
  
)

export default component.exports